// extracted by mini-css-extract-plugin
module.exports = {"editableCellValueWrap":"WishEditableCell_editableCellValueWrap__2VYfx"};